<template>
  <div class="cost">
    <div class="cost__wrapper">
      <div class="cost__wrapper__header">
        <div class="cost__wrapper__header__top">
          <router-link :to="{ name: 'sharing' }">
          <img src="/img/icons/ic-arrow-left.svg" alt="">
          Sharing
          </router-link>
        </div>
        <div class="cost__wrapper__header__bottom">
          <div class="cost__wrapper__header__bottom__left">
            <h1 class="medium-title">Additional Cost</h1>
            <p>{{ campaignName }}</p>
          </div>
          <div class="cost__wrapper__header__bottom__right">
            <h1 class="regular-font">{{ gross | formatMoney }}</h1>
            <h1 class="micro-font">Total Price (Gross)</h1>
          </div>
        </div>
        <div class="cost__wrapper__header__add">
          <button class="btn-regular primary" @click="add">Add Cost</button>
        </div>
      </div>
      <div class="cost__wrapper__list">
        <table>
          <thead>
            <tr>
              <td class="header">Cost Name</td>
              <td class="header">Cost Value</td>
              <td class="header"></td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(list, index) in lists" :key="index">
              <td class="body">{{ list.name }}</td>
              <td class="body">{{ list.amount | formatMoney }}</td>
              <td><button class="btn-small secondary" @click="goToDetail(list)">View</button></td>
            </tr>
          </tbody>
        </table>
        <adx-loading v-if="isLoading" slot="loading" class="loading"/>
        <div v-if="!isLoading && isEmpty">
          <div class="empty">
            <img src="/img/notfound/img-empty-draft@2x.png" alt="">
            <span class="text">Your data is empty.</span>
          </div>
        </div>
      </div>
      <modal v-if="isShowModal" @modal-close="closeModal" title="Add Cost / Campaign">
        <div slot="content" class="cost__wrapper__modal">
          <adx-input :label="`Cost Name`" class="row" :value.sync="model.costName"/>
          <adx-input :label="`Cost Value (Rp)`" class="row" :value.sync="model.costAmount" type="number"/>
          <div class="row2"><span>Sharing Schemes</span></div>
          <div class="row">
            <span>Adx</span>
            <adx-input :label="`Percentage`" class="field" v-model="adxShare" type="number" :disabled="true"/>
          </div>
          <div v-for="(role, index) in model.roles" :key="index" class="row">
            <span v-if="role.role == 1">Host</span>
            <span v-else-if="role.role == 2">Investor</span>
            <span v-else>Consultant</span>
            <adx-input :label="`Percentage`" class="field" :value.sync="role.share" type="number"/>
          </div>
          <div v-if="!isShareValid" class="row">
            <span class="error">Total percentage can't be higher than 100%</span>
          </div>
          <div class="buttons2">
            <div class="left"><button @click="addRole">Add more roles</button></div>
            <div class="right">
              <button class="btn-regular secondary" @click="closeModal">Cancel</button>
              <button class="btn-regular primary" @click="setCostSharing" :disabled="!isShareValid">Ok</button>
            </div>
          </div>
        </div>
      </modal>
      <modal v-if="isShowRoleModal" @modal-close="closeRoleModal" title="Add User Role">
        <div slot="content" class="cost__wrapper__modal">
          <div>
            <adx-select-dropdown :label="`User`" :options="userOptions" class="dropdown" :value.sync="newUser"/>
            <adx-select-dropdown :label="`Role`" :options="roleOptions" class="dropdown" :value.sync="newRole"/>
          </div>
          <div class="buttons1">
            <button class="btn-regular secondary" @click="closeRoleModal">Cancel</button>
            <button class="btn-regular primary" @click="saveNewRole">Save</button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import Checkbox from '@/components/Form/Checkbox'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-sharing-cost',
  components: {
    'adx-input': Input,
    'adx-checkbox': Checkbox,
    'adx-select-dropdown': SelectDropdown,
    'adx-loading': Loading,
    'adx-empty-selection': EmptySelection,
    Modal,
  },
  props: {

  },
  data() {
    return {
      isShowModal: false,
      isLoading: false,
      isEmpty: false,
      gross: 0,
      campaignName: null,
      isShareValid: null,
      isShowRoleModal: null,
      newRole: null,
      newUser: null,
      model: {
        id: null,
        costName: null,
        costAmount: null,
        roles: []
      },
      checkbox: '',
      lists: [],
      userOptions: [],
      roleOptions: [
        {
          value: 1,
          label: 'Host'
        },
        {
          value: 2,
          label: 'TV Investor'
        },
        {
          value: 3,
          label: 'Consultant'
        },
      ],
    }
  },
  computed: {
    adxShare: function () {
      let otherShare = 0
      this.model.roles.map(role => {
        otherShare += parseInt(role.share)
      })

      let totalShare = 100 - otherShare

      totalShare < 0 ? this.isShareValid = false : this.isShareValid = true

      return totalShare
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.initialLoad()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad() {
      (async () => {
        this.userOptions = []
        this.isLoading = true

        const userData = await api.get(apiV2.users, { needToken: true })
        userData.data.map(user => {
          this.userOptions.push(
            {
              value: user.id,
              label: user.email
            }
          )
        })

        const { data } = await api.get(apiV2.sharingCost(this.$route.params.id), { needToken: true })

        this.gross = data.data.campaign.price
        this.campaignName = data.data.campaign.name
        this.lists = data.data.costs

        !this.lists.length ? this.isEmpty = true : this.isEmpty = false

        this.isLoading = false
      })();
    },
    openModal(list) {
      this.isShowModal = !this.isShowModal
    },
    closeModal() {
      this.isShowModal = false
    },
    add() {
      this.isShowModal = true
    },
    addRole() {
      this.isShowRoleModal = true
    },
    closeRoleModal() {
      this.isShowRoleModal = false
    },
    setCostSharing() {
      this.model.roles.map(role => {
          let share = parseInt(role.share)/100
          role.share = share
        });
        (async () => {
          let data = {
            id: this.$route.params.id,
            name: this.model.costName,
            amount: parseInt(this.model.costAmount),
            roles: this.model.roles
          }
          
          const response = await api.post(apiV2.sharingCostAdd, data, { needToken: true })
          if (response.status == 201) {
            this.$notify({
              group: 'saved',
              title: status,
              text: 'Data successfully saved.',
              type: 'success'
            })
            this.isShowModal = false
            this.initialLoad()
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Sorry something went wrong!',
              type: 'danger'
            })
          }
        })();
    },
    goToDetail(list) {
      let params = {
        id: this.$route.params.id,
        costId: list.id
      }
      this.$router.push({ name: 'detailcost', params: params})
    },
    saveNewRole() {
      this.model.roles.push({
        role: this.newRole,
        user: this.newUser,
        share: 0,
      })
      
      this.newRole = null
      this.newUser = null
      this.isShowRoleModal = false
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.modal {

  &__content {
    width: 480px !important;
  }
}
</style>